import type { FormatMessages } from "@skilitics/localization";

export const invoicesFormatStrings = {
  title: {
    en: "Invoices",
  },
  createdDate: {
    en: "Date",
  },
  dueDate: {
    en: "Due",
  },
  description: {
    en: "Description",
  },
  status: {
    en: "Status",
  },
  amount: {
    en: "Total Amount",
  },
  invoice: {
    en: "Invoice",
  },
  noInvoicesMessage: {
    en: "No invoices found.",
  },
} satisfies FormatMessages;
